import { defineAsyncComponent, type Component } from "vue";

export const CONVERSATION_SETTINGS_SIDEBARS = {
  TYPES: {
    sidebar: "conversation-settings-types",
  },
} as const;

export type ConversationSettingsSidebarEntry =
  (typeof CONVERSATION_SETTINGS_SIDEBARS)[keyof typeof CONVERSATION_SETTINGS_SIDEBARS];
export type ConversationSettingsSidebarValue =
  ConversationSettingsSidebarEntry["sidebar"];

interface SidebarConfig {
  component: Component;
}

export const CONVERSATION_SETTINGS_SIDEBAR_COMPONENTS: Record<
  ConversationSettingsSidebarValue,
  SidebarConfig
> = {
  [CONVERSATION_SETTINGS_SIDEBARS.TYPES.sidebar]: {
    component: defineAsyncComponent(
      () =>
        import("conversations/components/settings/ConversationTypesDrawer.vue"),
    ),
  },
};
